import ajax from '@/utils/ajax'

/**
 * @module 规则中心接口
 */

 const BASE_URL = '/rule'

// 获取基础规则
export const getBaseList = (params) => ajax.post(`${BASE_URL}/baseRule`, params)

// 公示通知
export const getPublicityList = (params) => ajax.post(`${BASE_URL}/publicNotice`, params)

// 意见征集
export const getOpinionList = (params) => ajax.post(`${BASE_URL}/viewCollect`, params)

// 历史规则
export const getHistoryList = (params) => ajax.post(`${BASE_URL}/historyRule`, params)

// 规则详情
export const getRuleDetail = (params) => ajax.post(`${BASE_URL}/ruleDetail`, params)

/* 违规看板 */
// 分页查询违规列表
export const queryByPageVio = (params) => ajax.post(`/violation/queryByPage`, params)

// 获取公共枚举
export const commonEnumsVio = (params) => ajax.post(`/violation/commonEnums`, params)

// 撤销接口
export const cancelAppealVio = (params) => ajax.post(`/violation/cancelAppeal`, params)

// 申诉接口
export const appealVio = (params) => ajax.post(`/violation/appeal`, params)

// 导出接口
export const exportVio = (params) => ajax.post(`/violation/export`, params)

// 是否逾期
export const isExpiredAppealVio = (params) => ajax.post(`/violation/isExpiredAppeal`, params)

// 获取分值
export const getScore = (params) => ajax.post(`/violation/queryGasFraction`, params)

// 处罚记录
export const queryGasPunishRecords = (params) => ajax.post(`/violation/queryGasPunishRecords`, params)

// 违规记录通知
export const violationRecordNotice = (params) => ajax.post(`/violation/queryCompanyViolationRecordCheckNotice`, params)
